const {REACT_APP_USER_POOL_ID, REACT_APP_CLIENT_ID} = process.env;

export const CognitoConfig = {
    UserPoolId: REACT_APP_USER_POOL_ID || '',
    ClientId: REACT_APP_CLIENT_ID || '',
}
